import { Component, OnInit } from '@angular/core';
import { LoadingService } from '../services/loading.service';
import { DataService } from '../services/data.service';

@Component({
  selector: 'app-agent-modal',
  templateUrl: './agent-modal.component.html',
  styleUrls: ['./agent-modal.component.scss']
})
export class AgentModalComponent implements OnInit {

  public currentPage: string = "";
  public user: any = null;
  public showProfilePic: boolean = false;

  constructor(
    public loadingSvc: LoadingService,
    public dataSvc: DataService
  ) { }

  ngOnInit() {
    // this.loadDetails(null);
  }

  loadDetails(u: any) {
    this.currentPage = "Contact";
    this.user = u;
    this.loadingSvc.changeLoading("agent-modal.loadDetails", false);
    this.showProfilePic = false;
    if(this.user.Avatar !== null && this.user.Avatar !== undefined && this.user.Avatar !== ""){
      this.showProfilePic = true; 
      var baseUrl = window.location.origin.toString();
      if(baseUrl.includes("uat") || baseUrl.includes("staging"))
        baseUrl = "https://bc-acts-staging.enetenterprise.com";
      else
        baseUrl = "https://agent-counsellor-ukhub.britishcouncil.org";
      this.user.Avatar = baseUrl + "/publicmedia/" + this.user.Avatar;
    }

  }
}
